<template>
    <!-- Wing Tab Navigation -->
    <div class="section pt-1 mt-2">
        <div class="wallet-card">
            <div class="wallet-footer">
                <ul class="nav nav-tabs lined" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: filters.wing === '1' }" data-bs-toggle="tab" 
                           href="javascript:void(0)" role="tab" @click="onWingChange('1')">
                            {{ $t('wisdom') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: filters.wing === '2' }" data-bs-toggle="tab" 
                           href="javascript:void(0)" role="tab" @click="onWingChange('2')">
                            {{ $t('youth') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: filters.wing === '3' }" data-bs-toggle="tab" 
                           href="javascript:void(0)" role="tab" @click="onWingChange('3')">
                            {{ $t('students') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: filters.wing === '4' }" data-bs-toggle="tab" 
                           href="javascript:void(0)" role="tab" @click="onWingChange('4')">
                            {{ $t('women') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: filters.wing === '6' }" data-bs-toggle="tab" 
                           href="javascript:void(0)" role="tab" @click="onWingChange('6')">
                            {{ $t('girls') }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <!-- Filter Section with Accordion -->
    <div class="section inset mt-1 mb-1" v-if="!loading">
        <div class="accordion" id="accordionExample2">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#accordion001" aria-expanded="false">
                        <ion-icon name="filter-outline" role="img" class="md hydrated"
                            aria-label="wallet outline"></ion-icon>
                        Filter
                    </button>
                </h2>
                <div id="accordion001" class="accordion-collapse collapse" :class="hasActiveFilters ? 'show' : ''"
                    data-bs-parent="#accordionExample2" style="">
                    <div class="accordion-body">
                        <div id="search" style="padding: 0px !important;">
                            <!-- Zone Filter (for District and Zone Admins) -->
                            <div v-if="showZoneFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_zone">{{ $t('zone') }}</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.zone"
                                        name="filter_zone" id="select4" @change="onZoneChange">
                                        <option value>---All---</option>
                                        <option v-for="zone in zonesList" v-bind:value="zone.id" v-bind:key="zone.id">{{
                                            zone.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Unit Filter -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_unit">{{ $t('unit') }}</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.unit"
                                        name="filter_unit" id="select4" @change="onUnitChange">
                                        <option value>---All---</option>
                                        <option v-for="unit in unitsList" v-bind:value="unit.id" v-bind:key="unit.id">{{
                                            unit.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Designation/Position Filter -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_position">{{ $t('designation') }}</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.position"
                                        name="filter_position" id="select4">
                                        <option value>---All---</option>
                                        <option v-for="position in positionsList" v-bind:value="position.id" v-bind:key="position.id">{{
                                            position.value_mal || position.value }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Department Filter -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_department">{{ $t('department') }}</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.department"
                                        name="filter_department" id="select5" @change="onDepartmentChange">
                                        <option value>---All---</option>
                                        <option v-for="department in departmentsList" v-bind:value="department.id" v-bind:key="department.id">{{
                                            department.name_mal || department.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>



                            <div class="row">
                                <div class="col-6">
                                    <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;"
                                        @click="clearFilters()">
                                        <ion-icon name="trash-bin-outline" role="img" class="md hydrated"
                                            aria-label="add outline"></ion-icon>
                                        Clear
                                    </button>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;"
                                        @click="applyFilters()">
                                        <ion-icon name="search-outline" role="img" class="md hydrated"
                                            aria-label="add outline"></ion-icon>
                                        Filter
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Search Box -->
    <div id="search">
        <form class="search-form">
            <div class="form-group searchbox">
                <input type="text" class="form-control" :placeholder="$t('search')" v-model="searchQuery"
                    @input="filteredExecutives()">
                <i class="input-icon">
                    <ion-icon name="search-outline"></ion-icon>
                </i>
            </div>
        </form>
    </div>

    <!-- Loading -->
    <div class="section text-center mt-2" v-if="loading">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <!-- Summary Stats -->
    <div class="section" v-if="!loading && hierarchicalData.length > 0 && showTotalExecutivesCard">
        <div class="row mt-1">
            <div class="col-12">
                <div class="stat-box">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <div class="title mal-text text-primary">{{ $t('total_executives') }}</div>
                            <div class="value text-dark"><span class="text-primary">{{ totalExecutives }}</span></div>
                        </div>
                        <button type="button" class="btn btn-success btn-sm" @click="shareViaWhatsApp" 
                                v-if="totalExecutives > 0">
                            <ion-icon name="logo-whatsapp"></ion-icon>
                            Share
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Share Button for Zone Admins (when total card is hidden) -->
    <div class="section" v-if="!loading && hierarchicalData.length > 0 && !showTotalExecutivesCard">
        <div class="row mt-1">
            <div class="col-12">
                <button type="button" class="btn btn-success btn-sm w-100" @click="shareViaWhatsApp" 
                        v-if="totalExecutives > 0">
                    <ion-icon name="logo-whatsapp"></ion-icon>
                    Share List ({{ totalExecutives }} {{ $t('executives') }})
                </button>
            </div>
        </div>
    </div>

    <!-- Hierarchical Executive List -->
    <div v-for="zone in hierarchicalData" :key="zone.id" class="zone-section">
        <!-- Zone Header with Separator -->
        <div class="zone-header">
            <div class="listview-title mt-1 mb-1 mal-text text-primary" style="font-size: 15px; font-weight: bold;">
                {{ zone.name }} ({{ zone.total_executives }} {{ $t('executives') }})
            </div>
        </div>
        
        <div v-for="unit in zone.units" :key="unit.id" class="unit-section">
            <!-- Executives List for this Unit -->
            <ul class="listview image-listview inset text mt-0 mb-1" v-if="unit.executives.length > 0">
                <li v-for="(executive, index) in unit.executives" :key="executive.id">
                    <a href="javascript:void(0)" class="item">
                        <span class="sl-no">{{ index + 1 }}</span>
                        <div class="avatar-section">
                            <a href="#">
                                <img v-if="executive.member && executive.member.avatar && executive.member.avatar !== 'member.jpg'" 
                                     :src="'https://guide.msoftit.com/' + executive.member.avatar" 
                                     alt="avatar" class="image">
                                <img v-else 
                                     src="assets/img/sample/avatar/avatar1.png" 
                                     alt="avatar" class="image">
                            </a>
                        </div>
                        <div class="in">
                            <div class="min-width-50">
                                <b>{{ executive.member ? executive.member.name : 'N/A' }}</b>
                                <footer>
                                    <!-- Unit Name -->
                                    <span class="unit-name-badge">{{ unit.name }}</span>
                                    
                                    <!-- Contact Information -->
                                    <template v-if="shouldShowContactInfo(executive)">
                                        <span v-if="executive.member && executive.member.mobile">
                                            <br>{{ executive.member.country_code }} {{ executive.member.mobile }}
                                        </span>
                                        <span v-if="executive.member && executive.member.whatsapp_number">
                                            <br>WhatsApp: {{ executive.member.whatsapp_country_code || executive.member.country_code }} {{ executive.member.whatsapp_number }}
                                        </span>
                                    </template>
                                    
                                    <!-- Designation -->
                                    <span v-if="executive.user_sublevel_desc">
                                        <br><strong class="text-primary">{{ executive.user_sublevel_desc }}</strong>
                                    </span>
                                    
                                    <!-- Departments -->
                                    <span v-if="executive.departments && executive.departments.length > 0">
                                        <br><em class="text-muted">
                                            <span v-for="(dept, deptIndex) in executive.departments" :key="dept.id">
                                                {{ dept.name_mal || dept.name }}<span v-if="deptIndex < executive.departments.length - 1">, </span>
                                            </span>
                                        </em>
                                    </span>
                                </footer>
                            </div>
                            
                            <!-- Action Button - Only show for Women's and Girls' wing members -->
                            <div class="card-button dropdown" v-if="canShowActionModal">
                                <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                                    :data-bs-target="'#actionSheetInset'+executive.id">
                                    <ion-icon name="ellipsis-horizontal"></ion-icon>
                                </button>
                            </div>
                        </div>
                    </a>
                    
                    <!-- Action Sheet Modal - Only render for Women's and Girls' wing members -->
                    <div class="modal fade action-sheet" :id="'actionSheetInset'+executive.id" tabindex="-1" role="dialog" v-if="canShowActionModal">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Action</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list">
                                        <li v-if="executive.member && executive.member.mobile">
                                            <a :href="'tel:' + (executive.member.country_code || '+91') + executive.member.mobile" class="btn btn-list">
                                                <span>
                                                    <ion-icon name="call-outline"></ion-icon> Call
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="executive.member && (executive.member.whatsapp_number || executive.member.mobile)">
                                            <a :href="'https://wa.me/' + (executive.member.whatsapp_country_code || executive.member.country_code || '91') + (executive.member.whatsapp_number || executive.member.mobile) + '?text='" 
                                               class="btn btn-list">
                                                <span>
                                                    <ion-icon name="logo-whatsapp"></ion-icon> WhatsApp
                                                </span>
                                            </a>
                                        </li>
                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> Cancel
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            
            <!-- No executives message for unit -->
            <div v-if="unit.executives.length === 0" class="text-center p-2 text-muted">
                <em>{{ $t('no_executives_in_unit') }}</em>
            </div>
        </div>
        
        <!-- Zone Separator (except for last zone) -->
        <div v-if="hierarchicalData.indexOf(zone) < hierarchicalData.length - 1" class="zone-bottom-separator"></div>
    </div>

    <!-- No Data Message -->
    <div v-if="!loading && hierarchicalData.length === 0" class="text-center p-4">
        <p class="text-muted">{{ $t('no_executives_found') }}</p>
    </div>

    <!-- Pagination Component (following EventRegistrantsList pattern) -->
    <div class="section mt-2" v-if="!loading && !executivesLoading && executivesData && executivesData.total > 0">
        <vue-awesome-paginate 
            v-if="executivesData.total > executivesData.per_page"
            :total-items="executivesData.total" 
            :items-per-page="executivesData.per_page"
            :max-pages-shown="3" 
            v-model="executivesData.current_page" 
            :on-click="onPaginationClick"
            :show-ending-buttons="true" 
            :show-breakpoint-buttons="false" />
    </div>
</template>

<script>
import UserService from "../../services/user.service";
import { mapState } from "vuex";

export default {
    name: "DistrictZoneExecutiveList",
    
    data() {
        return {
            loading: false,
            hierarchicalData: [],
            originalHierarchicalData: [],
            originalExecutivesData: [],
            totalExecutives: 0,
            searchQuery: '',
            
            // Pagination data (following EventRegistrantsList pattern)
            executivesData: {
                data: [],
                total: 0,
                per_page: 20,
                current_page: 1,
                last_page: 1,
                from: 0,
                to: 0
            },
            executivesLoading: false,
            allComprehensiveData: [], // Store all data for client-side pagination
            isClientSidePagination: false, // Track if we're using client-side pagination
            
            // Filter data
            filters: {
                wing: '',
                zone: '',
                unit: '',
                position: '',
                department: ''
            },
            
            // Dropdown lists
            zonesList: [],
            unitsList: [],
            positionsList: [
                { id: '1', value: 'President', value_mal: 'പ്രസിഡന്റ്' },
                { id: '2', value: 'Vice President', value_mal: 'വൈസ് പ്രസിഡന്റ്' },
                { id: '3', value: 'General Secretary', value_mal: 'ജനറൽ സെക്രെട്ടറി' },
                { id: '4', value: 'Joint Secretary', value_mal: 'ജോയിന്റ് സെക്രെട്ടറി' },
                { id: '5', value: 'Treasurer', value_mal: 'ട്രഷറർ' },
                { id: '6', value: 'Executive Member', value_mal: 'എക്സിক്യൂട്ടീവ് മെമ്പർ' },
            ],
            departmentsList: [],
        };
    },

    computed: {
        ...mapState({
            currentUser: state => state.auth.user
        }),
        
        hasActiveFilters() {
            return this.filters.zone || this.filters.unit || this.filters.position || this.filters.department;
        },
        
        filterCount() {
            let count = 0;
            if (this.filters.zone) count++;
            if (this.filters.unit) count++;
            if (this.filters.position) count++;
            if (this.filters.department) count++;
            return count;
        },
        
        showZoneFilter() {
            // Zone filter should show for State Admins (level 1) and District Admins (level 2)
            // Zone Admins (level 3) can only view their own zone, so no zone filter needed
            
            if (!this.currentUser) {
                return false;
            }
            
            // Convert to number to ensure proper comparison
            const userLevel = parseInt(this.currentUser.user_level);
            
            // Only State Admin (level 1) and District Admin (level 2) need zone filter
            return userLevel === 1 || userLevel === 2;
        },
        
        showTotalExecutivesCard() {
            // Hide total executives card for Zone Admins (level 3)
            if (!this.currentUser) {
                return false;
            }
            
            // Convert to number to ensure proper comparison
            const userLevel = parseInt(this.currentUser.user_level);
            
            // Hide for Zone Admin (level 3)
            return userLevel !== 3;
        },
        
        canShowActionModal() {
            // Show 3-dot modal based on user's wing and current viewing wing
            if (!this.currentUser) {
                return false;
            }
            
            const userWing = this.currentUser.wing;
            const currentViewingWing = this.filters.wing;
            
            // Women's (4) and Girls' (6) members: can see 3-dot buttons on ALL wings
            if (userWing === 4 || userWing === 6) {
                return true;
            }
            
            // Org (1), Youth (2), Students (3) members: can see 3-dot buttons on Org, Youth, and Students wings only
            if (userWing === 1 || userWing === 2 || userWing === 3) {
                // Show 3-dot buttons when viewing Org (1), Youth (2), or Students (3) wings
                return currentViewingWing === '1' || currentViewingWing === '2' || currentViewingWing === '3';
            }
            
            // Default: hide for any other wings
            return false;
        },
        
        shouldShowContactInfo() {
            // Method to determine if contact information should be shown for executives
            return (executive) => {
                if (!this.currentUser) {
                    return false;
                }
                
                const userWing = this.currentUser.wing;
                const executiveWing = executive.wing_id || executive.wing || executive.wing_type;
                
                // Org (1), Youth (2), Students (3) members: cannot see Women's (4) and Girls' (6) contact info
                if (userWing === 1 || userWing === 2 || userWing === 3) {
                    return executiveWing !== 4 && executiveWing !== '4' && executiveWing !== 6 && executiveWing !== '6';
                }
                
                // Women's (4) and Girls' (6) members: can see all contact info
                if (userWing === 4 || userWing === 6) {
                    return true;
                }
                
                // Default: show contact info
                return true;
            };
        }
    },

    watch: {
        // Watch for route changes to refresh zones when district changes
        '$route'(to, from) {
            if (to.path !== from.path) {
                // Clear current zones to force refresh with correct district
                this.zonesList = [];
                this.unitsList = [];
                this.loadExecutivesList(1);
            }
        }
    },

    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            // Set default wing to Wisdom (1)
            this.filters.wing = '1';
            this.initializeComponent();
            this.$root.updateParent(this.$t('unit_level_executives'));
        }
    },

    methods: {
        initializeComponent() {
            // Parse URL first to get district context
            const urlPath = this.$route.path;
            const pathParts = urlPath.split('/').filter(p => p);
            let urlExtractedDistrictId = null;
            
            if (pathParts.length >= 3 && pathParts[0] === 'org') {
                const urlUserLevel = parseInt(pathParts[1]);
                const urlTargetId = parseInt(pathParts[2]);
                
                if (urlUserLevel === 2) {
                    urlExtractedDistrictId = urlTargetId;
                }
            }
            
            this.loadInitialData(urlExtractedDistrictId);
            this.loadExecutivesList(1);
        },

        async loadInitialData(targetDistrictId = null) {
            try {
                // Load zones for state and district admins (for filtering)
                if (this.currentUser.user_level === 1 || this.currentUser.user_level === 2) {
                    await this.loadZonesList(targetDistrictId);
                }
                
                // Load units for all admin levels
                await this.loadUnitsList();
                
                // Load departments for current wing
                await this.loadDepartmentsList();
            } catch (error) {
                // Silent error handling - component will work with empty lists
            }
        },

        async loadZonesList(targetDistrictId = null) {
            try {
                // If we have a specific district ID from URL, use it
                if (targetDistrictId) {
                    const response = await UserService.authPostRequest('get-zone-by-id', {
                        district_id: targetDistrictId
                    });
                    
                    if (response.data.status === 'success') {
                        this.zonesList = response.data.data.list || [];
                        return;
                    }
                }
                
                // Try multiple approaches to get zones
                const zoneAttempts = [
                    { params: {} },
                    { params: { user_level: 1, get_all: true } },
                    { params: { scope: 'state', level: 'all' } },
                    { params: { all_districts: true } }
                ];
                
                for (const attempt of zoneAttempts) {
                    try {
                        const response = await UserService.authPostRequest('get-zone-by-id', attempt.params);
                        
                        if (response.data.status === 'success' && response.data.data.list && response.data.data.list.length > 0) {
                            this.zonesList = response.data.data.list || [];
                            return;
                        }
                    } catch (attemptError) {
                        // Continue to next attempt
                    }
                }
                
                // Fallback: user's district only
                const response = await UserService.authPostRequest('get-zone-by-id', {
                    district_id: this.currentUser.district_id
                });
                
                if (response.data.status === 'success') {
                    this.zonesList = response.data.data.list || [];
                }
                
            } catch (error) {
                this.zonesList = [];
            }
        },

        async loadUnitsList() {
            try {
                // If a zone is selected in filters, load units from that zone
                if (this.filters.zone) {
                    const response = await UserService.authPostRequest('get-unit-by-id', {
                        zone_id: this.filters.zone
                    });
                    
                    if (response.data.status === 'success') {
                        this.unitsList = response.data.data.list || [];
                    }
                    return;
                }
                
                // Try to load ALL units
                const unitAttempts = [
                    { params: {} },
                    { params: { user_level: 1, get_all: true } },
                    { params: { scope: 'state', level: 'all' } },
                    { params: { all_zones: true, get_all_units: true } }
                ];
                
                for (const attempt of unitAttempts) {
                    try {
                        const response = await UserService.authPostRequest('get-unit-by-id', attempt.params);
                        
                        if (response.data.status === 'success' && response.data.data.list && response.data.data.list.length > 0) {
                            this.unitsList = response.data.data.list || [];
                            return;
                        }
                    } catch (attemptError) {
                        // Continue to next attempt
                    }
                }
                
                // Fallback: user's context
                let fallbackParams = {};
                if (this.currentUser.user_level == 2) {
                    fallbackParams.district_id = this.currentUser.district_id;
                } else if (this.currentUser.user_level == 3) {
                    fallbackParams.zone_id = this.currentUser.zone_id;
                }
                
                const response = await UserService.authPostRequest('get-unit-by-id', fallbackParams);
                if (response.data.status === 'success') {
                    this.unitsList = response.data.data.list || [];
                }
                
            } catch (error) {
                this.unitsList = [];
            }
        },

        async loadDepartmentsList() {
            try {
                // Try with user context first
                let data = {
                    wing: this.filters.wing,
                    user_level: 3,
                    level_id: this.currentUser.zone_id || this.currentUser.district_id
                };
                
                let response = await UserService.authPostRequest('get-departments', data);
                
                if (response.data.status === 'success' && response.data.data.list.length > 0) {
                    this.departmentsList = response.data.data.list;
                    return;
                }
                
                // Fallback: try without level_id
                data = {
                    wing: this.filters.wing,
                    user_level: 3
                };
                
                response = await UserService.authPostRequest('get-departments', data);
                
                if (response.data.status === 'success') {
                    this.departmentsList = response.data.data.list || [];
                } else {
                    this.departmentsList = [];
                }
            } catch (error) {
                this.departmentsList = [];
            }
        },

        getOrganizationLevel() {
            // Return the organizational level we're viewing departments for
            // District admin viewing zone/unit executives needs zone level departments (3)
            // Zone admin viewing unit executives needs unit level departments (4)
            if (this.currentUser.user_level == 2) {
                return 3; // District admin views zone level departments
            } else if (this.currentUser.user_level == 3) {
                return 4; // Zone admin views unit level departments  
            }
            return 3; // Default to zone level
        },

        getLevelId() {
            // Return the appropriate level ID based on what we're viewing
            if (this.currentUser.user_level == 2) {
                // District admin - if viewing zone executives, we might need zone_id
                // For now, try the selected zone or district_id
                return this.filters.zone || this.currentUser.district_id;
            } else if (this.currentUser.user_level == 3) {
                // Zone admin - if viewing unit executives, we might need unit_id
                // For now, try the selected unit or zone_id
                return this.filters.unit || this.currentUser.zone_id;
            } else if (this.currentUser.user_level == 4) {
                // Unit admin - use unit_id
                return this.currentUser.unit_id;
            }
            return null;
        },



        async getUserLocationNames() {
            // Get location names for display purposes if not already available
            
            // Get district name if needed
            if (!this.currentUser.district_name && this.currentUser.district_id) {
                try {
                    const response = await UserService.authPostRequest('get-district-by-id', {});
                    if (response.data.status === 'success') {
                        const districts = response.data.data.list || [];
                        const currentDistrict = districts.find(d => d.id == this.currentUser.district_id);
                        if (currentDistrict) {
                            this.currentUser.district_name = currentDistrict.name;
                        }
                    }
                } catch (error) {
                    // Silent error handling
                }
            }
            
            // Get zone name if needed
            if (!this.currentUser.zone_name && this.currentUser.zone_id) {
                try {
                    const response = await UserService.authPostRequest('get-zone-by-id', {district_id: this.currentUser.district_id});
                    if (response.data.status === 'success') {
                        const zones = response.data.data.list || [];
                        const currentZone = zones.find(z => z.id == this.currentUser.zone_id);
                        if (currentZone) {
                            this.currentUser.zone_name = currentZone.name;
                        }
                    }
                } catch (error) {
                    // Silent error handling
                }
            }
            
            // Get unit name if needed
            if (!this.currentUser.unit_name && this.currentUser.unit_id) {
                try {
                    const data = this.currentUser.zone_id ? {zone_id: this.currentUser.zone_id} : {district_id: this.currentUser.district_id};
                    const response = await UserService.authPostRequest('get-unit-by-id', data);
                    if (response.data.status === 'success') {
                        const units = response.data.data.list || [];
                        const currentUnit = units.find(u => u.id == this.currentUser.unit_id);
                        if (currentUnit) {
                            this.currentUser.unit_name = currentUnit.name;
                        }
                    }
                } catch (error) {
                    // Silent error handling
                }
            }
        },

        async loadExecutivesList(page = 1) {
            this.executivesLoading = true;
            this.loading = true;
            try {
                // Extract district ID and zone ID from URL FIRST
                const urlPath = this.$route.path;
                const pathParts = urlPath.split('/').filter(p => p);
                let urlExtractedDistrictId = null;
                let urlExtractedZoneId = null;
                
                if (pathParts.length >= 3 && pathParts[0] === 'org') {
                    const urlUserLevel = parseInt(pathParts[1]);
                    const urlTargetId = parseInt(pathParts[2]);
                    
                    if (urlUserLevel === 2) {
                        urlExtractedDistrictId = urlTargetId;
                    } else if (urlUserLevel === 3) {
                        urlExtractedZoneId = urlTargetId;
                    }
                }
                
                // Get location names for display purposes
                await this.getUserLocationNames();
                
                // Build API parameters
                const executiveParams = {};
                
                executiveParams.wing = this.filters.wing || '1';
                executiveParams.language = 'ml';
                executiveParams.term = 2;
                
                // Determine target IDs based on user level and filters
                let targetDistrictId = null;
                let targetZoneId = null;
                let targetUnitId = null;
                
                if (this.currentUser.user_level === 1) {
                    // State Admin
                    if (this.filters.unit && this.unitsList.length > 0) {
                        const selectedUnit = this.unitsList.find(u => u.id == this.filters.unit);
                        if (selectedUnit) {
                            targetDistrictId = selectedUnit.district_id;
                            targetZoneId = selectedUnit.zone_id;
                            targetUnitId = selectedUnit.id;
                        }
                    } else if (this.filters.zone && this.zonesList.length > 0) {
                        const selectedZone = this.zonesList.find(z => z.id == this.filters.zone);
                        if (selectedZone) {
                            targetDistrictId = selectedZone.district_id;
                            targetZoneId = selectedZone.id;
                        }
                    }
                } else if (this.currentUser.user_level === 2) {
                    // District Admin
                    if (this.filters.unit && this.unitsList.length > 0) {
                        const selectedUnit = this.unitsList.find(u => u.id == this.filters.unit);
                        if (selectedUnit) {
                            targetDistrictId = selectedUnit.district_id;
                            targetZoneId = selectedUnit.zone_id;
                            targetUnitId = selectedUnit.id;
                        }
                    } else if (this.filters.zone && this.zonesList.length > 0) {
                        const selectedZone = this.zonesList.find(z => z.id == this.filters.zone);
                        if (selectedZone) {
                            targetDistrictId = selectedZone.district_id;
                            targetZoneId = selectedZone.id;
                        }
                    }
                    
                } else if (this.currentUser.user_level === 3) {
                    // Zone Admin
                    if (this.filters.unit && this.unitsList.length > 0) {
                        const selectedUnit = this.unitsList.find(u => u.id == this.filters.unit);
                        if (selectedUnit) {
                            targetDistrictId = selectedUnit.district_id;
                            targetZoneId = selectedUnit.zone_id;
                            targetUnitId = selectedUnit.id;
                        }
                    }
                    
                } else {
                    // Unit Admin - Limited to their own unit
                    targetDistrictId = this.currentUser.district_id;
                    targetZoneId = this.currentUser.zone_id;
                    targetUnitId = this.currentUser.unit_id;
                }
                
                // Set the API parameters based on calculated targets
                // For comprehensive admin views, we use bypass flags when no specific filter is set
                
                if (this.currentUser.user_level === 1 && !targetDistrictId && !targetZoneId && !targetUnitId) {
                    // State Admin - Get all districts
                    executiveParams.get_all_districts = true;
                    executiveParams.admin_level_override = 1;
                    executiveParams.state_admin_access = true;
                    executiveParams.bypass_district_filter = true;
                } else if (this.currentUser.user_level === 2 && !targetZoneId && !targetUnitId) {
                    // District Admin - Get all zones from their district
                    executiveParams.district_id = this.currentUser.district_id;
                    executiveParams.force_district_id = this.currentUser.district_id;
                    executiveParams.target_district = this.currentUser.district_id;
                    
                    executiveParams.get_all_zones_in_district = true;
                    executiveParams.admin_level_override = 2;
                    executiveParams.district_admin_access = true;
                    executiveParams.bypass_zone_filter = true;
                } else if (this.currentUser.user_level === 3 && !targetUnitId) {
                    // Zone Admin - Get all units from their zone
                    const targetZoneIdForAPI = urlExtractedZoneId || this.currentUser.zone_id;
                    executiveParams.zone_id = targetZoneIdForAPI;
                    executiveParams.force_zone_id = targetZoneIdForAPI;
                    executiveParams.target_zone = targetZoneIdForAPI;
                    
                    executiveParams.get_all_units_in_zone = true;
                    executiveParams.admin_level_override = 3;
                    executiveParams.zone_admin_access = true;
                    executiveParams.bypass_unit_filter = true;
                } else {
                    // Specific filters applied or unit admin - use targeted parameters
                    if (targetDistrictId) {
                        executiveParams.district_id = targetDistrictId;
                        executiveParams.force_district_id = targetDistrictId;
                        executiveParams.target_district = targetDistrictId;
                        executiveParams.admin_district_override = targetDistrictId;
                    }
                    
                    if (targetZoneId) {
                        executiveParams.zone_id = targetZoneId;
                        executiveParams.force_zone_id = targetZoneId;
                        executiveParams.target_zone = targetZoneId;
                    }
                    
                    if (targetUnitId) {
                        executiveParams.unit_id = targetUnitId;
                        executiveParams.force_unit_id = targetUnitId;
                        executiveParams.target_unit = targetUnitId;
                    }
                }
                
                // Request parameters for comprehensive data
                executiveParams.scope = 'all';
                executiveParams.get_all_districts = true;
                executiveParams.get_all_zones = true;
                executiveParams.get_all_units = true;
                executiveParams.admin_mode = true;
                executiveParams.bypass_filters = true;
                executiveParams.ignore_context = true;
                
                // Set pagination parameters
                executiveParams.page = page;
                executiveParams.no_limit = true;
                executiveParams.unlimited = true;
                executiveParams.get_all_records = true;
                executiveParams.override_limit = true;
                executiveParams.limit = 10000;
                executiveParams.per_page = 10000;
                
                // Add department filter to API request if selected
                if (this.filters.department) {
                    executiveParams.department_id = this.filters.department;
                }
                
                executiveParams.request_source = 'DistrictZoneExecutiveList_' + Date.now();
                
                try {
                    if (urlExtractedDistrictId) {
                        executiveParams.district_id = urlExtractedDistrictId;
                        executiveParams.force_district_id = urlExtractedDistrictId;
                        executiveParams.target_district = urlExtractedDistrictId;
                        executiveParams.admin_district_override = urlExtractedDistrictId;
                        executiveParams.url_district_id = urlExtractedDistrictId;
                        executiveParams.override_user_district = urlExtractedDistrictId;
                        
                        delete executiveParams.bypass_district_filter;
                        delete executiveParams.get_all_districts;
                    } else if (urlExtractedZoneId) {
                        executiveParams.zone_id = urlExtractedZoneId;
                        executiveParams.force_zone_id = urlExtractedZoneId;
                        executiveParams.target_zone = urlExtractedZoneId;
                        executiveParams.admin_zone_override = urlExtractedZoneId;
                        executiveParams.url_zone_id = urlExtractedZoneId;
                        executiveParams.override_user_zone = urlExtractedZoneId;
                        
                        delete executiveParams.bypass_unit_filter;
                        delete executiveParams.get_all_units;
                    }
                    
                    let response = await UserService.authPostRequest('get-unit-executives-data', executiveParams);
                    
                    // Enhanced multi-zone fetching for District Admin
                    if (response.data && response.data.success && response.data.data && response.data.data.length > 0) {
                        if (this.currentUser.user_level === 2 && !targetZoneId && !targetUnitId && this.zonesList && this.zonesList.length > 1) {
                            try {
                                const allExecutivesData = [];
                                const currentWing = this.filters.wing || '1';
                                
                                for (const zone of this.zonesList) {
                                    try {
                                        const zoneParams = {
                                            wing: currentWing,
                                            language: 'ml',
                                            term: 2,
                                            district_id: urlExtractedDistrictId || this.currentUser.district_id,
                                            zone_id: zone.id,
                                            page: 1,
                                            no_limit: true,
                                            unlimited: true,
                                            get_all_records: true,
                                            override_limit: true,
                                            limit: 10000,
                                            per_page: 10000
                                        };
                                        
                                        // Add department filter if selected
                                        if (this.filters.department) {
                                            zoneParams.department_id = this.filters.department;
                                        }
                                        
                                        const zoneResponse = await UserService.authPostRequest('get-unit-executives-data', zoneParams);
                                        
                                        if (zoneResponse.data && zoneResponse.data.success && zoneResponse.data.data) {
                                            const zoneExecs = Array.isArray(zoneResponse.data.data) ? 
                                                            zoneResponse.data.data : 
                                                            (zoneResponse.data.data.data || []);
                                            allExecutivesData.push(...zoneExecs);
                                        }
                                    } catch (zoneError) {
                                        // Continue with next zone if one fails
                                    }
                                }
                                
                                if (allExecutivesData.length > 0) {
                                    response = {
                                        data: {
                                            success: true,
                                            data: allExecutivesData,
                                            total: allExecutivesData.length
                                        }
                                    };
                                }
                            } catch (multiZoneError) {
                                // Use original response if multi-zone fails
                            }
                        }
                    }
                    
                    // Check for alternative approaches if needed
                    // Try alternative approaches if needed
                    if (response.data && response.data.success && response.data.data && response.data.data.length > 0) {
                        const firstExecutive = response.data.data[0];
                        if (firstExecutive.district_name === 'TRIVANDRUM' || firstExecutive.district_id === 1) {
                            // Alternative Approach 1: Try different endpoint
                            try {
                                const altResponse1 = await UserService.authPostRequest('get-executives-data', {
                                    ...executiveParams,
                                    district_id: targetDistrictId,
                                    target_district_id: targetDistrictId,
                                    force_district: targetDistrictId
                                });
                                
                                if (altResponse1.data && altResponse1.data.success && altResponse1.data.data) {
                                    const altFirstExec = altResponse1.data.data[0];
                                    if (altFirstExec && altFirstExec.district_name !== 'TRIVANDRUM') {
                                        response = altResponse1;
                                    }
                                }
                            } catch (altError1) {
                                // Continue with original response
                            }
                            
                            // Alternative Approach 2: Try with explicit district filter
                            if (response.data.data[0].district_name === 'TRIVANDRUM') {
                                try {
                                    const altResponse2 = await UserService.authPostRequest('get-unit-executives-data', {
                                        wing: this.filters.wing || '1',
                                        language: 'ml',
                                        district_filter: targetDistrictId,
                                        where_district: targetDistrictId,
                                        district_equals: targetDistrictId,
                                        filter_by_district: targetDistrictId,
                                        page: page,
                                        no_limit: true,
                                        unlimited: true,
                                        get_all_records: true,
                                        override_limit: true,
                                        limit: 10000,
                                        per_page: 10000
                                    });
                                    
                                    if (altResponse2.data && altResponse2.data.success && altResponse2.data.data) {
                                        const altFirstExec2 = altResponse2.data.data[0];
                                        if (altFirstExec2 && altFirstExec2.district_name !== 'TRIVANDRUM') {
                                            response = altResponse2;
                                        }
                                    }
                                } catch (altError2) {
                                    // Continue with existing response
                                }
                            }
                        }
                    }
                    
                    if (response && response.data && response.data.success) {
                        // Since we removed limit, determine comprehensive view based on user level and filters only  
                        const isComprehensiveView = (this.currentUser.user_level <= 3) && (!targetUnitId);
                        

                        
                        // Handle paginated response structure (like EventRegistrantsList)
                        if (response.data.data && typeof response.data.data === 'object' && response.data.data.data) {
                            // Paginated response structure
                            const responseData = response.data.data.data || [];
                            
                            if (isComprehensiveView) {
                                // For comprehensive admin views, show ALL data WITH pagination

                                const defaultPerPage = 20; // Use reasonable pagination even in comprehensive mode
                                
                                // Store all data for client-side pagination
                                this.allComprehensiveData = responseData;
                                this.isClientSidePagination = true;
                                
                                // Show first page of data
                                const firstPageData = responseData.slice(0, defaultPerPage);
                                this.executivesData = {
                                    data: firstPageData,
                                    total: responseData.length,
                                    per_page: defaultPerPage,
                                    current_page: 1,
                                    last_page: Math.ceil(responseData.length / defaultPerPage),
                                    from: 1,
                                    to: Math.min(defaultPerPage, responseData.length)
                                };
                            } else {
                                // Normal pagination for unit-specific views
                                this.allComprehensiveData = [];
                                this.isClientSidePagination = false;
                                
                                this.executivesData = {
                                    data: responseData,
                                    total: response.data.data.total || 0,
                                    per_page: response.data.data.per_page || 20,
                                    current_page: response.data.data.current_page || 1,
                                    last_page: response.data.data.last_page || 1,
                                    from: response.data.data.from || 0,
                                    to: response.data.data.to || 0
                                };
                            }
                        } else {
                            // Simple array response
                            const allData = response.data.data || [];
                            
                            if (isComprehensiveView) {
                                // For comprehensive admin views, show ALL data without pagination

                                this.executivesData = {
                                    data: allData,
                                    total: allData.length,
                                    per_page: allData.length, // Show all on one page
                                    current_page: 1,
                                    last_page: 1,
                                    from: 1,
                                    to: allData.length
                                };
                            } else {
                                // Normal pagination for unit-specific views
                                const perPage = 20;
                                const totalItems = response.data.total || allData.length;
                                const totalPages = Math.ceil(totalItems / perPage);
                                const startIndex = (page - 1) * perPage;
                                const endIndex = startIndex + perPage;
                                const pageData = allData.slice(startIndex, endIndex);
                                
                                this.executivesData = {
                                    data: pageData,
                                    total: totalItems,
                                    per_page: perPage,
                                    current_page: page,
                                    last_page: totalPages,
                                    from: startIndex + 1,
                                    to: Math.min(endIndex, totalItems)
                                };
                            }
                        }
                        

                        // Client-side wing filtering
                        const expectedWingFilter = this.filters.wing || '1';
                        
                        const wingFilteredData = this.executivesData.data.filter(executive => {
                            const executiveWing = executive.wing_id || executive.wing || executive.wing_type || '1';
                            return executiveWing.toString() === expectedWingFilter;
                        });
                        
                        // Update executivesData with filtered results
                        if (wingFilteredData.length !== this.executivesData.data.length) {
                            this.executivesData.data = wingFilteredData;
                            this.executivesData.total = wingFilteredData.length;
                            this.executivesData.to = wingFilteredData.length;
                        }
                        
                        // Transform data and populate dropdowns
                        this.hierarchicalData = this.transformToHierarchical(this.executivesData.data);
                        this.totalExecutives = this.executivesData.total;
                        this.originalExecutivesData = [...this.executivesData.data];
                        this.populateFilterDropdownsFromData(this.executivesData.data);
                    } else {
                        // No data found
                        this.executivesData = {
                            data: [],
                            total: 0,
                            per_page: 20,
                            current_page: 1,
                            last_page: 1,
                            from: 0,
                            to: 0
                        };
                        this.hierarchicalData = [];
                        this.totalExecutives = 0;
                    }
                    
                } catch (apiError) {
                    this.executivesData = {
                        data: [],
                        total: 0,
                        per_page: 20,
                        current_page: 1,
                        last_page: 1,
                        from: 0,
                        to: 0
                    };
                    this.hierarchicalData = [];
                    this.totalExecutives = 0;
                }
                
            } catch (error) {
                this.executivesData = {
                    data: [],
                    total: 0,
                    per_page: 20,
                    current_page: 1,
                    last_page: 1,
                    from: 0,
                    to: 0
                };
                this.hierarchicalData = [];
                this.totalExecutives = 0;
            } finally {
                this.executivesLoading = false;
                this.loading = false;
            }
        },

        applyClientSideFilters(executivesData) {
            let filteredData = [...executivesData];
            
            // Filter by position/designation
            if (this.filters.position) {
                const selectedPosition = this.positionsList.find(pos => pos.id === this.filters.position);
                if (selectedPosition) {
                    filteredData = filteredData.filter(executive => {
                        const designation = executive.designation || executive.user_sublevel_desc || '';
                        return designation.toLowerCase().includes(selectedPosition.value.toLowerCase()) ||
                               designation.toLowerCase().includes(selectedPosition.value_mal?.toLowerCase() || '');
                    });
                }
            }
            
            // Filter by department - use exact matching to avoid "Education" matching "Informal Education"
            if (this.filters.department) {
                const selectedDepartment = this.departmentsList.find(dept => dept.id == this.filters.department);
                if (selectedDepartment) {
                    filteredData = filteredData.filter(executive => {
                        const departments = executive.departments || '';
                        if (!departments) return false;
                        
                        // Handle both string (comma-separated) and array formats
                        let departmentArray = [];
                        if (typeof departments === 'string') {
                            // Split by comma and clean up
                            departmentArray = departments.split(',').map(d => d.trim().toLowerCase()).filter(d => d && d !== 'none');
                        } else if (Array.isArray(departments)) {
                            // If it's an array, extract names
                            departmentArray = departments.map(dept => {
                                const name = typeof dept === 'string' ? dept : (dept.name || dept.name_mal || '');
                                return name.trim().toLowerCase();
                            }).filter(d => d);
                        }
                        
                        const selectedNameLower = selectedDepartment.name?.trim().toLowerCase() || '';
                        const selectedNameMalLower = selectedDepartment.name_mal?.trim().toLowerCase() || '';
                        
                        // Check for exact match in the department list
                        return departmentArray.some(dept => 
                            dept === selectedNameLower || dept === selectedNameMalLower
                        );
                    });
                }
            }
            
            return filteredData;
        },

        updateUnitsBasedOnZone() {
            if (!this.filters.zone || !this.originalExecutivesData) {
                // If no zone selected, show all units
                this.populateFilterDropdownsFromData(this.originalExecutivesData);
                return;
            }
            
            // Filter units based on selected zone
            const unitsInZone = [];
            const unitIds = new Set();
            
            this.originalExecutivesData.forEach(executive => {
                if (executive.zone_id == this.filters.zone && 
                    executive.unit_id && executive.unit_name && 
                    !unitIds.has(executive.unit_id)) {
                    unitsInZone.push({
                        id: executive.unit_id,
                        name: executive.unit_name,
                        zone_id: executive.zone_id,
                        zone_name: executive.zone_name,
                        district_id: executive.district_id,
                        district_name: executive.district_name
                    });
                    unitIds.add(executive.unit_id);
                }
            });
            
            this.unitsList = unitsInZone.sort((a, b) => a.name.localeCompare(b.name));
            

        },

        populateFilterDropdownsFromData(executiveData) {
            if (!executiveData || !Array.isArray(executiveData) || executiveData.length === 0) {
                return;
            }
            

            
            // Extract unique zones from executive data - only from the correct districts
            const uniqueZones = [];
            const zoneIds = new Set();
            
            executiveData.forEach(executive => {
                if (executive.zone_id && executive.zone_name && !zoneIds.has(executive.zone_id)) {
                    uniqueZones.push({
                        id: executive.zone_id,
                        name: executive.zone_name,
                        district_id: executive.district_id,
                        district_name: executive.district_name
                    });
                    zoneIds.add(executive.zone_id);
                }
            });
            
            // Extract unique units from executive data
            const uniqueUnits = [];
            const unitIds = new Set();
            
            executiveData.forEach(executive => {
                if (executive.unit_id && executive.unit_name && !unitIds.has(executive.unit_id)) {
                    uniqueUnits.push({
                        id: executive.unit_id,
                        name: executive.unit_name,
                        zone_id: executive.zone_id,
                        zone_name: executive.zone_name,
                        district_id: executive.district_id,
                        district_name: executive.district_name
                    });
                    unitIds.add(executive.unit_id);
                }
            });
            
            // Extract unique positions/designations from executive data
            const uniquePositions = [];
            const positionTexts = new Set();
            let positionIdCounter = 1;
            
            executiveData.forEach(executive => {
                const designation = executive.designation || executive.user_sublevel_desc || '';
                if (designation && !positionTexts.has(designation)) {
                    uniquePositions.push({
                        id: positionIdCounter.toString(),
                        value: designation,
                        value_mal: designation // Since most seem to be in Malayalam already
                    });
                    positionTexts.add(designation);
                    positionIdCounter++;
                }
            });
            
            // Update the zones, units, and positions lists
            // Only update zones if we don't already have zones loaded from the correct district
            if (this.zonesList.length === 0 || uniqueZones.length > 0) {
                this.zonesList = uniqueZones.sort((a, b) => a.name.localeCompare(b.name));
            }
            this.unitsList = uniqueUnits.sort((a, b) => a.name.localeCompare(b.name));
            const secretariatOption = {
                id: 'secretariat_members',
                value: 'Secretariat Members',
                value_mal: 'സെക്രട്ടേറിയറ്റ് അംഗങ്ങൾ'
            };
            this.positionsList = [secretariatOption, ...uniquePositions.sort((a, b) => a.value.localeCompare(b.value))];
            

        },

        transformToHierarchical(flatData) {
            if (!flatData || !Array.isArray(flatData) || flatData.length === 0) {
                return [];
            }
            
            const zonesMap = new Map();
            
            flatData.forEach((executive) => {
                
                const zoneKey = executive.zone_name || 'Unknown Zone';
                const unitKey = executive.unit_name || 'Unknown Unit';
                
                if (!zonesMap.has(zoneKey)) {
                    zonesMap.set(zoneKey, {
                        name: zoneKey,
                        units: new Map(),
                        total_executives: 0
                    });
                }
                
                const zone = zonesMap.get(zoneKey);
                
                if (!zone.units.has(unitKey)) {
                    zone.units.set(unitKey, {
                        name: unitKey,
                        executives: []
                    });
                }
                
                const unit = zone.units.get(unitKey);
                
                // Transform API data to executive structure
                unit.executives.push({
                    id: executive.id,
                    wing: executive.wing,
                    wing_name: executive.wing_name,
                    designation: executive.designation,
                    user_sublevel_desc: executive.user_sublevel_desc || executive.designation,
                    user_sublevel: executive.user_sublevel,
                    departments: executive.departments ? 
                        executive.departments.split(', ').map(name => ({ name })) : [],
                    member: {
                        name: executive.member_name,
                        mobile: executive.member_phone ? executive.member_phone.replace(/\+\d+\s*/, '') : '',
                        country_code: executive.member_phone && executive.member_phone.startsWith('+91') ? '+91' : '+91',
                        whatsapp_number: executive.member_phone ? executive.member_phone.replace(/\+\d+\s*/, '') : '',
                        whatsapp_country_code: executive.member_phone && executive.member_phone.startsWith('+91') ? '+91' : '+91',
                        avatar: executive.avatar || null // Handle case where avatar might not be in API response
                    },
                    district_name: executive.district_name,
                    zone_name: executive.zone_name,
                    unit_name: executive.unit_name,
                    created_at: executive.created_at,
                    updated_at: executive.updated_at
                });
                
                zone.total_executives++;
            });
            
            // Convert maps to arrays
            const result = Array.from(zonesMap.values()).map(zone => ({
                ...zone,
                units: Array.from(zone.units.values())
            }));
            

            return result;
        },

        calculateTotalExecutives() {
            let total = 0;
            this.hierarchicalData.forEach(zone => {
                zone.units.forEach(unit => {
                    total += unit.executives.length;
                });
            });
            return total;
        },

        // Search functionality
        filteredExecutives() {
            if (!this.searchQuery.trim()) {
                this.hierarchicalData = [...this.originalHierarchicalData];
                this.totalExecutives = this.calculateTotalExecutives();
                return;
            }

            const searchLower = this.searchQuery.toLowerCase();
            
            // Filter the original flat data first
            const filteredFlatData = this.originalExecutivesData.filter(executive => {
                const memberName = executive.member_name?.toLowerCase() || '';
                const mobile = executive.member_phone?.toLowerCase() || '';
                const designation = executive.designation?.toLowerCase() || '';
                const unitName = executive.unit_name?.toLowerCase() || '';
                const zoneName = executive.zone_name?.toLowerCase() || '';
                
                return memberName.includes(searchLower) || 
                       mobile.includes(searchLower) || 
                       designation.includes(searchLower) ||
                       unitName.includes(searchLower) ||
                       zoneName.includes(searchLower);
            });
            
            // Transform filtered data back to hierarchical structure
            this.hierarchicalData = this.transformToHierarchical(filteredFlatData);
            this.totalExecutives = filteredFlatData.length;
        },

        // Filter event handlers
        onWingChange(wing) {
            this.filters.wing = wing;
            this.filters.department = ''; // Reset department when wing changes
            
            // Clear existing data immediately to prevent showing old wing data during loading
            this.executivesData = {
                data: [],
                total: 0,
                per_page: 10,
                current_page: 1,
                from: 0,
                to: 0
            };
            this.hierarchicalData = [];
            this.originalExecutivesData = [];
            this.totalExecutives = 0;
            
            // Set loading state
            this.loading = true;
            this.executivesLoading = true;
            
            this.loadDepartmentsList(); // Reload departments for new wing
            this.loadExecutivesList(1); // Reload data with new wing - wing changes need fresh API call
        },

        onZoneChange() {
            // Update units list based on selected zone
            this.updateUnitsBasedOnZone();
            this.filters.unit = ''; // Reset unit when zone changes
            this.filters.department = ''; // Reset department when zone changes
            this.loadDepartmentsList(); // Reload departments for new zone
            // Don't apply filters automatically - wait for user to click Filter button
        },

        onUnitChange() {
            // Don't apply filters automatically - wait for user to click Filter button
        },

        onDepartmentChange() {
            // Don't apply filters automatically - wait for user to click Filter button
        },

        applyFilters() {
            // If we don't have original data loaded, reload from API
            if (!this.originalExecutivesData || this.originalExecutivesData.length === 0) {
                this.loadExecutivesList(1);
                return;
            }
            
            // Apply client-side filters to the original data
            let filteredData = [...this.originalExecutivesData];
            
            // Filter by zone
            if (this.filters.zone) {
                filteredData = filteredData.filter(executive => 
                    executive.zone_id == this.filters.zone
                );
            }
            
            // Filter by unit
            if (this.filters.unit) {
                filteredData = filteredData.filter(executive => 
                    executive.unit_id == this.filters.unit
                );
            }
            
            // Filter by position
            if (this.filters.position) {
                const selectedPosition = this.positionsList.find(pos => pos.id === this.filters.position);
                if (selectedPosition) {
                    if (selectedPosition.id === 'secretariat_members') {
                        filteredData = filteredData.filter(executive => {
                            const designationRaw = `${executive.designation || ''} ${executive.user_sublevel_desc || ''}`.trim();
                            const designation = designationRaw.toLowerCase().replace(/\s+/g, ' ').trim();

                            // Never include Executive Members in secretariat filter
                            if (
                                designation.includes('executive member') ||
                                designation.includes('എക്സിക്യൂട്ടീവ്') ||
                                designation.includes('എക്സിക്യൂട്ടിവ്') ||
                                designation.includes('എക്സി')
                            ) {
                                return false;
                            }

                            const englishMatchers = [
                                /\bpresident\b/i,
                                /\bvice president\b/i,
                                /\b(?:general|gen\.?)\s+secretary\b/i,
                                /\bsecretary\b/i,
                                /\bjoint secretary\b/i,
                                /\btreasurer\b/i,
                                /\btrusurer\b/i,
                                /\btresurer\b/i,
                                /\btrasurer\b/i,
                                /\btreasur\w*\b/i,
                            ];
                            const malMatchers = [
                                'പ്രസിഡ',
                                'വൈസ്',
                                'ജനറൽ',
                                'സെക്ര',
                                'സെക്രട്ട',
                                'ജോയിന്റ്',
                                'ട്രഷ',
                                'ട്രെഷ',
                                'ട്രഷറ',
                                'ഖജ',
                                'ഖജാൻ',
                                'ഖജന',
                                'ഖജാന',
                                'ഖജാൻജി',
                                'ഭണ്ഡ',
                                'ഭണ്ഡാരി'
                            ];

                            return englishMatchers.some(re => re.test(designationRaw)) || malMatchers.some(k => designation.includes(k));
                        });
                    } else {
                        filteredData = filteredData.filter(executive => {
                            const designation = executive.designation || executive.user_sublevel_desc || '';
                            // Since positions are now extracted from actual data, do exact match
                            return designation === selectedPosition.value;
                        });
                    }

                }
            }
            
            // Filter by department - use exact matching to avoid "Education" matching "Informal Education"
            if (this.filters.department) {
                const selectedDepartment = this.departmentsList.find(dept => dept.id == this.filters.department);
                if (selectedDepartment) {
                    filteredData = filteredData.filter(executive => {
                        const departments = executive.departments || '';
                        if (!departments) return false;
                        
                        // Handle both string (comma-separated) and array formats
                        let departmentArray = [];
                        if (typeof departments === 'string') {
                            // Split by comma and clean up
                            departmentArray = departments.split(',').map(d => d.trim().toLowerCase()).filter(d => d && d !== 'none');
                        } else if (Array.isArray(departments)) {
                            // If it's an array, extract names
                            departmentArray = departments.map(dept => {
                                const name = typeof dept === 'string' ? dept : (dept.name || dept.name_mal || '');
                                return name.trim().toLowerCase();
                            }).filter(d => d);
                        }
                        
                        const selectedNameLower = selectedDepartment.name?.trim().toLowerCase() || '';
                        const selectedNameMalLower = selectedDepartment.name_mal?.trim().toLowerCase() || '';
                        
                        // Check for exact match in the department list
                        return departmentArray.some(dept => 
                            dept === selectedNameLower || dept === selectedNameMalLower
                        );
                    });
                }
            }
            
            // Apply search filter if there's a search query
            if (this.searchQuery && this.searchQuery.trim()) {
                const searchLower = this.searchQuery.toLowerCase();
                filteredData = filteredData.filter(executive => {
                    const memberName = executive.member_name?.toLowerCase() || '';
                    const mobile = executive.member_phone?.toLowerCase() || '';
                    const designation = executive.designation?.toLowerCase() || '';
                    const unitName = executive.unit_name?.toLowerCase() || '';
                    const zoneName = executive.zone_name?.toLowerCase() || '';
                    
                    return memberName.includes(searchLower) || 
                           mobile.includes(searchLower) || 
                           designation.includes(searchLower) ||
                           unitName.includes(searchLower) ||
                           zoneName.includes(searchLower);
                });

            }
            
            // Update the displayed data
            this.executivesData.data = filteredData;
            this.executivesData.total = filteredData.length;
            this.executivesData.to = filteredData.length;
            this.hierarchicalData = this.transformToHierarchical(filteredData);
            this.totalExecutives = filteredData.length;
            

        },

        clearFilters() {
            this.filters = {
                wing: '1',
                zone: '',
                unit: '',
                position: '',
                department: ''
            };
            this.searchQuery = ''; // Clear search query too
            
            // Restore original data immediately
            if (this.originalExecutivesData && this.originalExecutivesData.length > 0) {
                this.executivesData.data = [...this.originalExecutivesData];
                this.executivesData.total = this.originalExecutivesData.length;
                this.executivesData.to = this.originalExecutivesData.length;
                this.hierarchicalData = this.transformToHierarchical(this.originalExecutivesData);
                this.totalExecutives = this.originalExecutivesData.length;
                
                // Repopulate filter dropdowns
                this.populateFilterDropdownsFromData(this.originalExecutivesData);
            } else {
                // Fallback: reload from API if no original data
                this.loadUnitsList();
                this.loadExecutivesList(1);
            }
        },





        // Helper method for cookie reading
        getCookieSimple(name) {
            const nameEQ = name + "=";
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                let cookie = cookies[i];
                while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length);
                if (cookie.indexOf(nameEQ) === 0) {
                    try {
                        return JSON.parse(decodeURIComponent(cookie.substring(nameEQ.length, cookie.length)));
                    } catch (e) {
                        return null;
                    }
                }
            }
            return null;
        },

        // Debug method to try completely different API approach
        async debugDirectAPICall() {
            console.log('🔧 DEBUGGING: Trying direct API call with context override');
            
            try {
                // Get auth token
                const userCookie = this.getCookieSimple('user');
                const token = userCookie && userCookie.accessToken ? userCookie.accessToken : null;
                
                if (!token) {
                    console.error('No auth token found');
                    return null;
                }
                
                // Try multiple approaches to bypass server filtering
                const attempts = [
                    {
                        name: 'Minimal params',
                        params: {
                            wing: '1',
                            language: 'ml'
                        }
                    },
                    {
                        name: 'Admin override',
                        params: {
                            wing: '1',
                            language: 'ml',
                            user_level: '1', // Try admin level
                            district_id: null,
                            zone_id: null,
                            unit_id: null,
                            override_context: true
                        }
                    },
                    {
                        name: 'State level request',
                        params: {
                            wing: '1',
                            language: 'ml',
                            scope: 'state',
                            level: 'state',
                            get_all_districts: true
                        }
                    },
                    {
                        name: 'Different district test',
                        params: {
                            wing: '1',
                            language: 'ml',
                            district_id: '1', // Try a different district ID
                            force_district: '1'
                        }
                    }
                ];
                
                for (const attempt of attempts) {
                    console.log(`🔧 Trying ${attempt.name} with params:`, attempt.params);
                    
                    try {
                        // Make direct fetch call to bypass all middleware
                        const response = await fetch('https://guide.msoftit.com/api/get-unit-executives-data', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token,
                                'Accept': 'application/json'
                            },
                            body: JSON.stringify(attempt.params)
                        });
                        
                        const data = await response.json();
                        console.log(`🔧 ${attempt.name} response:`, data);
                        
                        if (data && data.success && data.data && data.data.length > 0) {
                            // Check if we got different district data
                            const districts = [...new Set(data.data.map(exec => exec.district_name))];
                            console.log(`🔧 ${attempt.name} got ${data.data.length} records from districts:`, districts);
                            
                            if (districts.length > 1 || (districts.length === 1 && districts[0] !== 'TRIVANDRUM')) {
                                console.log(`✅ ${attempt.name} SUCCESS - Got data from multiple/different districts!`);
                                return data;
                            }
                        }
                    } catch (attemptError) {
                        console.error(`🔧 ${attempt.name} failed:`, attemptError);
                    }
                }
                
                console.log('🔧 All direct API attempts returned same filtered data or failed');
                return null;
                
            } catch (error) {
                console.error('🔧 Direct API call method failed:', error);
                return null;
            }
        },

        // Alternative API attempt
        async tryAlternativeAPI() {
            console.log('🔄 Trying alternative API endpoints for all-data access...');
            
            const alternatives = [
                { 
                    endpoint: 'get-members-list', 
                    params: { 
                        type: 'executive', 
                        wing: this.filters.wing || '1',
                        scope: 'all',
                        user_level: 1,
                        get_all_districts: true
                    } 
                },
                { 
                    endpoint: 'get-executives-list', 
                    params: { 
                        wing: this.filters.wing || '1',
                        scope: 'state',
                        all_districts: true
                    } 
                },
                { 
                    endpoint: 'get-all-members', 
                    params: { 
                        wing: this.filters.wing || '1',
                        filter: 'executives',
                        level: 'state'
                    } 
                },
                { 
                    endpoint: 'members/search', 
                    params: { 
                        wing: this.filters.wing || '1',
                        type: 'executive',
                        search: '',
                        scope: 'global'
                    } 
                },
                { 
                    endpoint: 'get-unit-executives', 
                    params: { 
                        wing: this.filters.wing || '1',
                        all: true
                    } 
                },
                { 
                    endpoint: 'admin/get-all-executives', 
                    params: { 
                        wing: this.filters.wing || '1'
                    } 
                }
            ];
            
            for (const alt of alternatives) {
                try {
                    console.log(`🔄 Trying ${alt.endpoint} with params:`, alt.params);
                    const response = await UserService.authPostRequest(alt.endpoint, alt.params);
                    console.log(`🔄 ${alt.endpoint} response structure:`, {
                        success: response.data?.success,
                        status: response.data?.status,
                        data_length: response.data?.data?.length || response.data?.data?.list?.length || 0,
                        has_pagination: !!(response.data?.page || response.data?.limit)
                    });
                    
                    if (response.data && (response.data.success || response.data.status === 'success')) {
                        let dataArray = response.data.data;
                        if (response.data.data && response.data.data.list) {
                            dataArray = response.data.data.list;
                        }
                        
                        if (dataArray && dataArray.length > 0) {
                            // Check if we get different districts
                            const districts = [...new Set(dataArray.map(exec => exec.district_name))];
                            console.log(`🔄 ${alt.endpoint} got ${dataArray.length} records from districts:`, districts);
                            
                            if (districts.length > 1 || (districts.length === 1 && districts[0] !== 'TRIVANDRUM')) {
                                console.log(`✅ ${alt.endpoint} SUCCESS - Multiple districts found!`);
                                return response.data;
                            }
                        }
                    }
                } catch (error) {
                    console.log(`❌ ${alt.endpoint} failed:`, error.message);
                }
            }
            
            console.log('🔄 All alternative APIs either failed or returned same district-filtered data');
            return null;
        },

        // Method to test fetching data from all possible districts
        async testAllDistrictsData() {
            console.log('🌍 TESTING: Trying to fetch data from all districts...');
            
            // First, get list of all districts
            try {
                const districtsResponse = await UserService.authPostRequest('get-district-by-id', {});
                if (districtsResponse.data && districtsResponse.data.status === 'success') {
                    const allDistricts = districtsResponse.data.data.list || [];
                    console.log('🌍 Found districts:', allDistricts.map(d => `${d.id}: ${d.name}`));
                    
                    const allExecutivesData = [];
                    
                    // Try to fetch executives from each district
                    for (const district of allDistricts.slice(0, 3)) { // Test first 3 districts only
                        try {
                            console.log(`🌍 Fetching executives from district ${district.id}: ${district.name}`);
                            
                            const districtParams = {
                                wing: this.filters.wing || '1',
                                language: 'ml',
                                district_id: district.id,
                                force_district_context: district.id,
                                override_user_context: true,
                                admin_access: true,
                                // Explicitly request unlimited data
                                no_limit: true,
                                unlimited: true,
                                get_all_records: true,
                                override_limit: true,
                                limit: 10000,
                                per_page: 10000
                            };
                            
                            const response = await UserService.authPostRequest('get-unit-executives-data', districtParams);
                            if (response.data && response.data.success && response.data.data) {
                                console.log(`🌍 District ${district.name} returned ${response.data.data.length} executives`);
                                allExecutivesData.push(...response.data.data);
                            }
                            
                        } catch (districtError) {
                            console.log(`🌍 District ${district.name} failed:`, districtError.message);
                        }
                    }
                    
                    if (allExecutivesData.length > 0) {
                        const uniqueDistricts = [...new Set(allExecutivesData.map(e => e.district_name))];
                        console.log(`🌍 SUCCESS: Got ${allExecutivesData.length} executives from districts:`, uniqueDistricts);
                        return allExecutivesData;
                    }
                }
            } catch (error) {
                console.error('🌍 Failed to get districts list:', error);
            }
            
            return null;
        },

        // Utility methods
        getWingName(wing) {
            const wingNames = {
                '1': this.$t('wisdom'),
                '2': this.$t('youth'),
                '3': this.$t('students'),
                '4': this.$t('women'),
                '5': this.$t('balavedi'),
                '6': this.$t('girls')
            };
            return wingNames[wing] || 'Unknown';
        },

        // Export and Print methods
        exportData() {
            // Create export data in format suitable for Excel/CSV
            const exportData = this.prepareExportData();
            this.downloadAsCSV(exportData);
        },

        prepareExportData() {
            const data = [];
            
            // Add headers
            data.push([
                'Zone',
                'Unit',
                'Name',
                'Wing',
                'Position',
                'Mobile',
                'WhatsApp'
            ]);

            // Add data rows
            this.hierarchicalData.forEach(zone => {
                zone.units.forEach(unit => {
                    unit.executives.forEach(executive => {
                        data.push([
                            zone.name,
                            unit.name,
                            executive.member ? executive.member.name : 'N/A',
                            this.getWingName(executive.wing),
                            executive.user_sublevel_desc || '',
                            executive.member && executive.member.mobile 
                                ? `+${executive.member.country_code} ${executive.member.mobile}` 
                                : '',
                            executive.member && executive.member.whatsapp_number 
                                ? `+${executive.member.whatsapp_country_code || executive.member.country_code} ${executive.member.whatsapp_number}` 
                                : ''
                        ]);
                    });
                });
            });

            return data;
        },

        downloadAsCSV(data) {
            // Convert data to CSV format
            const csvContent = data.map(row => 
                row.map(field => 
                    typeof field === 'string' && field.includes(',') 
                        ? `"${field}"` 
                        : field
                ).join(',')
            ).join('\n');

            // Create and download the file
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            
            link.setAttribute('href', url);
            link.setAttribute('download', `executives_list_${new Date().toISOString().split('T')[0]}.csv`);
            link.style.visibility = 'hidden';
            
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        printList() {
            window.print();
        },

        // Pagination methods (following EventRegistrantsList pattern)
        onPaginationClick(page) {

            
            if (this.isClientSidePagination && this.allComprehensiveData.length > 0) {
                // Handle client-side pagination for comprehensive data

                
                const perPage = this.executivesData.per_page;
                const startIndex = (page - 1) * perPage;
                const endIndex = startIndex + perPage;
                const pageData = this.allComprehensiveData.slice(startIndex, endIndex);
                
                // Update executivesData with new page
                this.executivesData = {
                    ...this.executivesData,
                    data: pageData,
                    current_page: page,
                    from: startIndex + 1,
                    to: Math.min(endIndex, this.allComprehensiveData.length)
                };
                
                // Update hierarchical display
                this.hierarchicalData = this.transformToHierarchical(pageData);
                
            } else {
                // Handle server-side pagination

                this.loadExecutivesList(page);
            }
        },

        refreshExecutives() {
            this.loadExecutivesList(1);
        },

        shareViaWhatsApp() {
            try {
                // Get current wing name
                const wingName = this.getWingName(this.filters.wing || '1');
                
                // Build the share text
                let shareText = `*${this.$t('unit_level_executives')} - ${wingName}*\n\n`;
                
                // Add filter information if any filters are active
                const activeFilters = [];
                if (this.filters.zone) {
                    const selectedZone = this.zonesList.find(z => z.id == this.filters.zone);
                    if (selectedZone) {
                        activeFilters.push(`Zone: ${selectedZone.name}`);
                    }
                }
                if (this.filters.unit) {
                    const selectedUnit = this.unitsList.find(u => u.id == this.filters.unit);
                    if (selectedUnit) {
                        activeFilters.push(`Unit: ${selectedUnit.name}`);
                    }
                }
                if (this.filters.position) {
                    const selectedPosition = this.positionsList.find(pos => pos.id === this.filters.position);
                    if (selectedPosition) {
                        activeFilters.push(`Designation: ${selectedPosition.value_mal || selectedPosition.value}`);
                    }
                }
                if (this.filters.department) {
                    const selectedDepartment = this.departmentsList.find(dept => dept.id == this.filters.department);
                    if (selectedDepartment) {
                        activeFilters.push(`Department: ${selectedDepartment.name_mal || selectedDepartment.name}`);
                    }
                }
                
                if (activeFilters.length > 0) {
                    shareText += `*Filters:* ${activeFilters.join(', ')}\n\n`;
                }
                
                shareText += `*Total: ${this.totalExecutives} ${this.$t('executives')}*\n\n`;
                shareText += `━━━━━━━━━━━━━━━━━━━━\n\n`;
                
                // Add executive details
                let executiveCount = 0;
                this.hierarchicalData.forEach((zone, zoneIndex) => {
                    if (zoneIndex > 0) {
                        shareText += `\n`;
                    }
                    
                    shareText += `*${zone.name}*\n`;
                    
                    zone.units.forEach((unit) => {
                        if (unit.executives.length > 0) {
                            shareText += `\n_${unit.name}_\n`;
                            
                            unit.executives.forEach((executive) => {
                                executiveCount++;
                                shareText += `${executiveCount}. *${executive.member ? executive.member.name : 'N/A'}*\n`;
                                
                                // Add designation
                                if (executive.user_sublevel_desc) {
                                    shareText += `   ${executive.user_sublevel_desc}\n`;
                                }
                                
                                // Add contact info if visible
                                if (this.shouldShowContactInfo(executive)) {
                                    if (executive.member && executive.member.mobile) {
                                        shareText += `   📞 ${executive.member.country_code} ${executive.member.mobile}\n`;
                                    }
                                    if (executive.member && executive.member.whatsapp_number) {
                                        shareText += `   💬 WhatsApp: ${executive.member.whatsapp_country_code || executive.member.country_code} ${executive.member.whatsapp_number}\n`;
                                    }
                                }
                                
                                // Add departments
                                if (executive.departments && executive.departments.length > 0) {
                                    const deptNames = executive.departments.map(dept => dept.name_mal || dept.name).join(', ');
                                    shareText += `   📋 ${deptNames}\n`;
                                }
                                
                                shareText += `\n`;
                            });
                        }
                    });
                });
                
                shareText += `━━━━━━━━━━━━━━━━━━━━\n`;
                shareText += `*Generated from Wisdom Guide App*\n`;
                
                // Encode the text for URL
                const encodedText = encodeURIComponent(shareText);
                
                // Create WhatsApp share URL
                const whatsappUrl = `https://wa.me/?text=${encodedText}`;
                
                // Open WhatsApp in new window/tab
                window.open(whatsappUrl, '_blank');
                
            } catch (error) {
                console.error('Error sharing via WhatsApp:', error);
                alert('Failed to share. Please try again.');
            }
        }
    }
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.image-listview.text>li:after {
    left: 0px;
    background-color: #1a418c;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: bold;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.avatar-section .abroad {
    background: #0962d2;
}

.avatar-section .payment-verified {
    background: #05d0a4;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.09);
    border-radius: 10px;
    padding: 10px 10px;
}

.stat-box .btn-success {
    background-color: #25D366;
    border-color: #25D366;
    color: white;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 6px;
}

.stat-box .btn-success:hover {
    background-color: #20BA5A;
    border-color: #20BA5A;
    color: white;
}

.stat-box .btn-success ion-icon {
    font-size: 18px;
}

/* Tab Navigation Styling - Matching ElectionOfficers exactly */
.nav-link.active {
    background-color: #007bff;
    color: white;
}

.action .btn-sm {
    height: auto;
    width: auto;
    margin-right: 5px;
}

/* Zone and Unit Separators */
.zone-section {
    margin-bottom: 12px;
}

.zone-header {
    position: relative;
    padding: 0 8px;
}

.zone-bottom-separator {
    height: 1px;
    background: #e9ecef;
    margin: 12px 0;
    border-radius: 1px;
}

.unit-section {
    margin-bottom: 4px;
}

/* Unit name badge styling */
.unit-name-badge {
    display: inline-block;
    background: #e3f2fd;
    color: #1976d2;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    margin-right: 6px;
    margin-bottom: 4px;
}

.listview>li footer {
    font-size: 12px;
    line-height: 1.4;
    padding-top: 4px;
}

/* Enhanced listview styling for better grouping - Mobile optimized */
.zone-section .listview {
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0,0,0,0.08);
    margin-bottom: 4px;
}

.zone-section .listview li:first-child .item {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.zone-section .listview li:last-child .item {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
}

/* Reduce padding in list items for mobile */
.zone-section .listview .item {
    padding: 10px 12px;
    min-height: auto;
}

.zone-section .listview .item .in {
    padding-left: 8px;
}

/* Compact avatar sizing */
.zone-section .avatar-section .image {
    width: 40px;
    height: 40px;
}

/* Reduce spacing in sl-no */
.sl-no {
    font-weight: 700;
    margin-right: 8px;
    font-size: 13px;
    min-width: 20px;
}

/* Mobile-specific optimizations */
@media (max-width: 768px) {
    .zone-section {
        margin-bottom: 8px;
    }
    
    .zone-header .listview-title {
        font-size: 14px !important;
        margin-top: 8px !important;
        margin-bottom: 6px !important;
        padding: 0 4px;
    }
    
    .zone-section .listview .item {
        padding: 8px 10px;
    }
    
    .zone-section .listview .item .in {
        padding-left: 6px;
    }
    
    .zone-section .avatar-section .image {
        width: 36px;
        height: 36px;
    }
    
    .unit-name-badge {
        font-size: 10px;
        padding: 2px 6px;
    }
    
    .listview>li footer {
        font-size: 11px;
        line-height: 1.3;
    }
    
    .min-width-50 {
        min-width: 55% !important;
    }
}

@media print {
    .section:first-child, .action, #search {
        display: none !important;
    }
    
    .listview>li {
        break-inside: avoid;
        page-break-inside: avoid;
    }
    
    .zone-section {
        break-inside: avoid;
        page-break-inside: avoid;
    }
    
    .unit-section {
        break-inside: avoid;
        page-break-inside: avoid;
    }
}
</style>